import moment from 'moment'
import *as backend from '../../store/backend'
import { cToF, formatTime } from '../../utils'

type StepData = {
  step?: number | undefined;
  currentTime?: number | undefined;
  totalTime?: number | undefined;
  temperature: number;
  day: number;
  hour: number;
  minutes: number;
}



export type TemperatureDisplayProps = {

  style?: React.CSSProperties
  temperature?: number
  humidity?: number
  humidityEnabled?: boolean
  state: backend.ActiveLogAck['data']['state'] | 'LOGGING' | 'LOGGED'
  finishedAt?: string
  startedAt?: string
  steps: StepData[]
  runCurrentTime?: number
  runTotalTime?: number
  runTotalText?: string
  dateFormat?: string
  unit?: 'C' | 'F' | undefined

}
function TemperatureDisplay(props: TemperatureDisplayProps) {


  const colors = [
    'bg-stepColor1',
    'bg-stepColor2',
    'bg-stepColor3',
    'bg-stepColor4',
  ]




  type NewStep = (StepData & {
    totalWidth?: number;
    currentWidth?: number;
  })

  let steps: NewStep[] = props.steps.map((item, index) => {
    if (item.day === -1) {
      item.currentTime = 0
      item.totalTime = props.steps.reduce((pv, cv) => {
        if (cv.day === -1) {
          return pv
        }
        return pv + (cv.totalTime || 0)
      }, 0) * 0.3
    }
    return item
  })

  const dateFormat = props.dateFormat || 'DD.MM.YYYY'

  const unit = props.unit === 'F' ? '℉' : '℃'





  if (props.state === 'LOGGED') {
    return (
      <div className="temperature-display flex"
        style={{
          justifyContent: 'center',
          flexDirection: 'column',
          ...props.style || {}
        }}
      >

        <div
          style={{
            fontWeight: 700,
            color: 'white',
            textAlign: 'center',
            fontSize: 35,
            display: 'flex',
            flexDirection: 'row',
          }}

        >Started: {props.startedAt && moment(props.startedAt).format(`${dateFormat} h:mma`)}</div>

        <div
          style={{
            fontWeight: 700,
            color: 'white',
            textAlign: 'center',
            fontSize: 35,
            display: 'flex',
            flexDirection: 'row',
          }}

        >Total Time: {props.runTotalText ? props.runTotalText : formatTime(props.runTotalTime || 0)}</div>
        <div
          style={{
            fontWeight: 700,
            color: 'white',
            textAlign: 'center',
            fontSize: 35,
            display: 'flex',
            flexDirection: 'row',
          }}

        >Finished: {props.finishedAt && moment(props.finishedAt).format(`${dateFormat} h:mma`)}</div>

      </div>
    )
  }


  if (props.state === 'FINISHED' || props.state === 'LOGGING') {
    return (
      <div className="temperature-display flex"
        style={{
          justifyContent: 'center',
          flexDirection: 'column',
          ...props.style || {}
        }}
      >
        <div
          style={{
            fontWeight: 700,
            color: 'white',
            textAlign: 'center',
            fontSize: 35,
            display: 'flex',
            flexDirection: 'row',
          }}

        >Total Time: {props.runTotalText ? props.runTotalText : formatTime(props.runTotalTime || 0)}</div>
        <div
          style={{
            fontWeight: 700,
            color: 'white',
            textAlign: 'center',
            fontSize: 35,
            display: 'flex',
            flexDirection: 'row',
          }}

        >Finished: {props.finishedAt && moment(props.finishedAt).format(`${dateFormat} h:mma`)}</div>

      </div>
    )
  }



  const calculateWidths = (steps: NewStep[]): NewStep[] => {
    // 计算所有步骤的总时间

    const totalTimes = steps.reduce((acc, step) => acc + (step.totalTime || 0), 0);

    // 计算每个step的基本totalWidth
    steps.forEach(step => {
      let width = (step.totalTime || 0) / totalTimes * 100 || 0
      step.totalWidth = width < 15 ? 15 : width;
    });

    // 确保所有的totalWidth之和为100%
    const totalWidthSum = steps.reduce((acc, step) => acc + step.totalWidth!, 0);

    if (totalWidthSum > 100) {
      const excess = totalWidthSum - 100;
      const excessPortion = excess / steps.length;
      steps.forEach(step => step.totalWidth = step.totalWidth! - excessPortion);

    } else if (totalWidthSum < 100) {
      const deficit = 100 - totalWidthSum;
      const deficitPortion = deficit / steps.length;
      steps.forEach(step => step.totalWidth = step.totalWidth! + deficitPortion);
    }

    // 计算每个step的currentWidth
    steps.forEach(step => {
      step.currentWidth = ((step.currentTime || 0) / (step.totalTime || 0)) * step.totalWidth! || 0
    });

    return steps;
  }


  steps = calculateWidths(steps)


  const progressWidth = steps.reduce((pv, cv) => {
    return pv + (cv.currentWidth || 0)
  }, 0)


  const progress = Math.trunc(progressWidth)

  return (
    <div className="temperature-display flex"
      style={{
        // justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <div
        style={{
          fontWeight: 700,
          color: 'white',
          textAlign: 'center',
          fontSize: 45,
          display: 'flex',
          flexDirection: 'row',
          ...props.style || {},
        }}

      >Temperature:&nbsp;<div style={{
        minWidth: 180,
      }}>{unit === '℉' ? cToF(props.temperature || 0) || '-' : props.temperature?.toFixed(1) || '-'}{unit}</div></div>

      {props.humidityEnabled && (
        <div
          style={{
            fontWeight: 700,
            color: 'white',
            textAlign: 'center',
            fontSize: 45,
            display: 'flex',
            flexDirection: 'row',
            marginTop: -10,
            ...props.style || {},
          }}

        >Humidity:&nbsp;<div style={{
          minWidth: 180,
        }}>{props.humidity?.toFixed(1) || "0.0"}%</div>
        </div>
      )}



      <div
        style={{
          height: 35,
          width: 700,
          position: 'relative',
          marginTop: 49,
          flexDirection: 'row',
          display: 'flex',
        }}
      >
        <div
          style={{
            width: '100%',
            height: '100%',
            position: 'relative',
            flexDirection: 'row',
            overflow: 'hidden',
            display: 'flex',
            borderRadius: 35 / 2,
          }}
        >
          {steps.map((item, index) => {
            return (
              <div
                className={`${colors[index]}`}
                key={index}
                style={{
                  height: '100%',
                  width: `${item.totalWidth}%`,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  color: 'white',
                  fontSize: 24,
                  fontWeight: 400,
                  borderLeftWidth: index === 0 ? 0 : 0.5,
                }}
              >
                {index + 1}
              </div>
            )
          })}

          <div
            style={{
              position: 'absolute',
              left: 0,
              right: 0,
              margin: 0,
              border: 0,
              zIndex: 3,
              flexDirection: 'row',
              display: 'flex',
            }}
          >
            {steps.map((item, index) => {
              return (
                  <div
                    key={index}
                    style={{
                      height: '100%',
                      width: `${item.totalWidth}%`,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      color: 'white',
                      fontSize: 24,
                      fontWeight: 400,
                    }}
                  >
                    {index + 1}
                  </div>


              )
            })}
          </div>


          <div
            style={{
              position: 'absolute',
              zIndex: 1,
              left: -0,
              top: -5,
              bottom: -5,
              right: 0,
              display: 'flex',
              flexDirection: 'row',
            }}
          >
            <div
              style={{
                width: `${progress}%`,
                backgroundColor: '#676767',
                height: 35,
                marginTop: 5,
                overflow: 'hidden',
                position: 'relative',
              }}
            >
              <div
                style={{
                  position: 'absolute',
                  left: 0,
                  top: 0,
                  height: '100%',
                  width: 700,
                  display: 'flex',
                  flexDirection: 'row',
                }}
              >
                {steps.map((item, index) => {

                  return (
                    <div
                      key={index}
                    >
                      <div
                        key={index}
                        style={{
                          height: '100%',
                          width: `${item.totalWidth}%`,
                        }}
                      />
                      <div
                        style={{
                          height: '100%',
                          width: index === steps.length - 1 ? 0 : 0.5,
                          backgroundColor: 'white',
                        }}
                      />
                    </div>

                  )
                })}
              </div>

            </div>

          </div>

        </div>

        {/* 移动进度条 */}
        <div
          style={{
            position: 'absolute',
            zIndex: 10,
            left: -0,
            top: -5,
            bottom: -5,
            right: 0,
            display: 'flex',
            flexDirection: 'row',
          }}
        >

          <div
            style={{
              width: `${progress}%`,
              height: 35,
              marginTop: 5,
            }}
          />
          <div
            style={{
              height: '100%',
              width: 6,
              borderRadius: 6 / 2,
              borderWidth: 1,
              borderColor: 'white',
              backgroundColor: '#676767',
              marginBottom: 10,
              position: 'relative',
            }}
          >
            {/* 移动进度条顶部 */}
            <div
              style={{
                position: 'absolute',
                width: 60,
                height: 25,
                borderWidth: 2,
                borderColor: 'white',
                borderRadius: 25 / 2,
                left: -(60 / 2) + 3,
                top: -30,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: 'white',
                fontSize: 16,
              }}
            >
              {progress}%
            </div>
          </div>

        </div>
      </div>
      <div
        style={{
          fontWeight: 700,
          color: 'white',
          textAlign: 'right',
          fontSize: 22,
          alignSelf: 'self-end',
        }}
      >{formatTime(props.runCurrentTime || 0)} <span style={{ padding: '0px 5px' }}>/</span> {formatTime(props.runTotalTime || 0)}</div>
    </div>
  );
}

export default TemperatureDisplay;




